import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function initAnimations() {
    // Fade In Up
    gsap.utils.toArray('.fade-in-up').forEach(element => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: "top 85%",
                toggleActions: "play none none reverse"
            },
            y: 50,
            opacity: 0,
            duration: 1,
            ease: "power3.out"
        });
    });

    // Fade In Left
    gsap.utils.toArray('.fade-in-left').forEach(element => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: "top 85%",
                toggleActions: "play none none reverse"
            },
            x: -50,
            opacity: 0,
            duration: 1,
            ease: "power3.out"
        });
    });

    // Fade In Right
    gsap.utils.toArray('.fade-in-right').forEach(element => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: "top 85%",
                toggleActions: "play none none reverse"
            },
            x: 50,
            opacity: 0,
            duration: 1,
            ease: "power3.out"
        });
    });
}

/**
 * Generic entrance animation function using GSAP.
 * Can be used on load or combined with ScrollTrigger for scroll animations.
 * 
 * @param {HTMLElement|NodeList|string} targets - The selector or elements to animate.
 * @param {Object} options - Configuration options for the animation.
 */
export function animateEntrance(targets, options = {}) {
    const defaults = {
        yPercent: 40,
        duration: 0.6,
        stagger: 0.08,
        ease: "power3.out",
        scrollTrigger: false,
        trigger: null,
        start: "top 85%"
    };

    const settings = { ...defaults, ...options };
    const elements = typeof targets === 'string' ? document.querySelectorAll(targets) : targets;
    if (!elements || elements.length === 0) return null;

    // Set initial states
    gsap.set(elements, { opacity: 0, yPercent: settings.yPercent });

    const timelineOptions = {};
    if (settings.scrollTrigger) {
        timelineOptions.scrollTrigger = {
            trigger: settings.trigger || elements[0],
            start: settings.start,
            toggleActions: "play none none none"
        };
    }

    const tl = gsap.timeline(timelineOptions);
    tl.to(elements, {
        opacity: 1,
        yPercent: 0,
        duration: settings.duration,
        stagger: settings.stagger,
        ease: settings.ease,
        clearProps: "transform"
    });

    return tl;
}

